import profileImage from "../assets/img/avatars/profileImage.jpg";
import { handleSupplierRequestAction } from "actions/actions";
import { toast } from "react-toastify";
import ImageModal from "../components/imageModel/imageMode.jsx";
import { useState } from "react";
import { localizeStatus, localizeSupplierTypes } from "utils/localization";

const BASE_URL = process.env.REACT_APP_ENDPOINT;

const SupplierRequestsColumn = (refetch) => [
  {
    Header: "اسم المورد",
    accessor: "name",
    Cell: ({ row }) => {
      const [isModalOpen, setIsModalOpen] = useState(false);
      return (
        <div className="flex min-w-[140px] items-center gap-3">
          <img
            src={
              row.original.photo
                ? `${BASE_URL}/${row.original?.photo}`
                : profileImage
            }
            alt="avatar"
            className="h-10 w-10 rounded-full border border-gray-200"
            crossOrigin="anonymous"
            onClick={() => setIsModalOpen(true)}
          />
          {isModalOpen && (
            <ImageModal
              src={
                row.original.photo
                  ? `${BASE_URL}/${row.original?.photo}`
                  : profileImage
              }
              onClose={() => setIsModalOpen(false)}
            />
          )}
          <span className="font-medium">{row.original.name || "—"}</span>
        </div>
      );
    },
  },
  {
    Header: "رقم الهاتف",
    accessor: "phoneNumber",
  },
  {
    Header: "الرقم الضريبي",
    accessor: "supplierInfo.taxNumber",
    Cell: ({ row }) => row.original?.supplierInfo?.taxNumber || "—",
  },
  {
    Header: "السجل التجاري",
    accessor: "supplierInfo.commercialRegister",
    Cell: ({ row }) => row.original?.supplierInfo?.commercialRegister || "—",
  },
  {
    Header: "ملف التعريف",
    accessor: "supplierInfo.profilePdf",
    Cell: ({ row }) => {
      const pdf = row.original?.supplierInfo?.profilePdf;
      if (!pdf) return "—";
      return (
        <a
          className="text-blue-500 hover:underline"
          href={`${BASE_URL}/${pdf}`}
          target="_blank"
          rel="noreferrer"
        >
          عرض الملف
        </a>
      );
    },
  },
  {
    Header: "أنواع التوريد",
    accessor: "supplierInfo.types",
    Cell: ({ row }) => localizeSupplierTypes(row.original?.supplierInfo?.types),
  },
  {
    Header: "الحالة",
    accessor: "status",
    Cell: ({ row }) => {
      const status = row.original.status;
      const colour =
        status === "accepted"
          ? "bg-green-500"
          : status === "rejected"
          ? "bg-red-500"
          : "bg-amber-500";
      return (
        <span className={`rounded-full px-2 py-1 text-xs text-white ${colour}`}>
          {localizeStatus(status)}
        </span>
      );
    },
  },
  {
    Header: "إجراء",
    accessor: "id",
    Cell: ({ row }) => {
      const disabled =
        row.original.status === "accepted" ||
        row.original.status === "rejected";
      return (
        <div className="flex items-start gap-2">
          <button
            className="rounded-full bg-green-500 px-6 py-1 text-white transition-all hover:bg-green-600 disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-400"
            disabled={disabled}
            onClick={() =>
              handleSupplierRequestAction(row.original.id, "accepted").then(
                (res) => {
                  if (res.error) toast.error(res.error);
                  else {
                    toast.success(res.success);
                    refetch();
                  }
                }
              )
            }
          >
            قبول
          </button>
          <button
            className="rounded-full bg-red-500 px-6 py-1 text-white transition-all hover:bg-red-600 disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-400"
            disabled={disabled}
            onClick={() =>
              handleSupplierRequestAction(row.original.id, "reject").then(
                (res) => {
                  if (res.error) toast.error(res.error);
                  else {
                    toast.success(res.success);
                    refetch();
                  }
                }
              )
            }
          >
            رفض
          </button>
        </div>
      );
    },
  },
];

export default SupplierRequestsColumn;
